import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useFormik } from "formik";
import TextField from '@mui/material/TextField'
import { styled } from '@mui/material/styles';
import MessageCard from './MessageCard'
import IconButton from '@mui/material/IconButton';
import ClearIcon from '@mui/icons-material/Clear';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import ProofLogTable from './ProofLogTable';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import SendIcon from '@mui/icons-material/Send';
import InputAdornment from '@mui/material/InputAdornment';

const SendMessage = (props) => {
    const VisuallyHiddenInput = styled('input')({
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)',
        height: 1,
        overflow: 'hidden',
        position: 'absolute',
        bottom: 0,
        left: 0,
        whiteSpace: 'nowrap',
        width: 1,
    });

    const { is_loading,
        job_id,
        action_type,
        create_send_message,
        tab_index,
        handleSetTabIndex,
        proof_log_data,
        canShowApprovalLog
    } = props;

    const handleTabChange = (event, newValue) => {
        handleSetTabIndex(newValue);
    };
    React.useEffect(() => {
        if (!canShowApprovalLog && tab_index === 1) {
            handleSetTabIndex(0);
        }
    }, [canShowApprovalLog, tab_index, handleSetTabIndex]);

    const onSubmit = async (values) => {
        const payload = { job_id, action_type, ...values };
        let res = await create_send_message(payload);
        if (res && !res.error) {
            formik.resetForm();
        } else {
            const errorMsg = res?.payload?.detail || res?.payload || "Failed to send message";
            alert("Error: " + errorMsg);
        }
    }

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            message: "",
            attachment: null,
        },
        onSubmit: (values) => {
            onSubmit(values);
        },
    });

    const emptyText = !formik.values.message.trim()


    return (
        <Box
            sx={{
                mt: 2,
                bgcolor: '#fff'
            }}
        >
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: -5, bgcolor: '#fff' }}>
                <Box sx={{ bgcolor: '#fff' }}>
                    <Tabs
                        value={tab_index}
                        onChange={handleTabChange}
                        textColor="inherit"
                        sx={{
                            '& .MuiTabs-indicator': { backgroundColor: '#ff6100' },
                            '& .Mui-selected': { color: '#ff6100', fontWeight: 'bold' },
                            mb: 0
                        }}
                    >
                        <Tab label="Job Log" sx={{ textTransform: 'none', minWidth: 'auto', mr: 2 }} />
                        {canShowApprovalLog && (
                            <Tab label="Approval Log" sx={{ textTransform: 'none', minWidth: 'auto' }} />
                        )}
                    </Tabs>
                </Box>

                {tab_index === 0 && (
                    <Box sx={{ width: '400px', bgcolor: '#fff' }}>
                        <form onSubmit={formik.handleSubmit}>
                            <TextField
                                id='message'
                                sx={{ width: '100%!important', bgcolor: '#fff', mt: 2, ml: -2.5 }}
                                placeholder='Type your message:'
                                variant="outlined"
                                multiline
                                minRows={3}
                                maxRows={3}
                                name="message"
                                value={formik.values.message}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end" sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            height: '100%',
                                            justifyContent: 'flex-start',
                                            alignItems: 'flex-end',
                                            py: 1,
                                            mr: 0,
                                            bgcolor: '#fff'
                                        }}>
                                            <IconButton
                                                type="submit"
                                                edge="end"
                                                onClick={(e) => {
                                                    if (emptyText || is_loading) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                                disabled={emptyText || is_loading}
                                                sx={{
                                                    color: '#ff6100',
                                                    p: 2,
                                                    width: 32,
                                                    height: 32,
                                                    '&.Mui-disabled': { color: '#ccc' }
                                                }}
                                            >
                                                <SendIcon sx={{ fontSize: 20, mt: '-5rem', transform: "rotate(-45deg)", transformOrigin: "center" }} />
                                            </IconButton>

                                            <IconButton
                                                component="label"
                                                edge="end"
                                                sx={{
                                                    color: '#9e9e9e',
                                                    p: 0,
                                                    width: 32,
                                                    height: 32
                                                }}
                                                disabled={!!(is_loading && formik.values.message)}
                                            >
                                                <AttachFileIcon sx={{ fontSize: 20, transform: 'rotate(45deg)' }} />
                                                <VisuallyHiddenInput
                                                    type="file"
                                                    onChange={(event) =>
                                                        formik.setFieldValue('attachment', event.target.files[0])
                                                    }
                                                />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                                error={
                                    formik.touched.message && Boolean(formik.errors.message)
                                }
                                helperText={
                                    (formik.touched.message && formik.errors.message) ||
                                    (formik.values.attachment ? `Attached: ${formik.values.attachment.name}` : '')
                                }
                            />
                        </form>
                    </Box>
                )}
            </Box>

            <Box sx={{ mt: tab_index === 1 ? '55px' : 0, bgcolor: '#fff' }}>
                {tab_index === 0 && <MessageCard job_id={job_id} />}
                {tab_index === 1 && canShowApprovalLog && (
                    <ProofLogTable job_id={job_id} proof_log_data={proof_log_data} />
                )}
            </Box>
        </Box>
    );
};

export default SendMessage;